// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Премјештено: ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Акција ' + p['label'] + ' је завршена',
  accButtonProgressStatus: (p: { label: string }) => 'Акција ' + p['label'] + ' је у току',
  accColorPalette: () => 'Палета боја',
  accColorSwatch: () => 'Библиотека боја',
  accCommandKey: () => 'Наредба',
  accContextMenuLabel: () => 'акције',
  accControlKey: () => 'Затвори',
  accPositionAfter: () => 'након',
  accPositionBefore: () => 'прије',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Притисните и држите ' +
    p['keyPressed'] +
    ' и типку Shift, а затим промијените редослијед помоћу типки са стрелицама.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Унеси потпун датум у овом формату: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Унеси мјесец и годину у овом формату: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Ознака',
  chart_labelGroup: () => 'Група',
  chart_labelSeries: () => 'Серија',
  chart_labelValue: () => 'Вриједност',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Изабери вриједност.',
  checkbox_helpForCheckbox: () => 'Помоћ за потврдни оквир',
  checkbox_requiredMessageDetail: () => 'Изабери вриједност.',
  checkbox_selected: () => 'Оквир је потврђен',
  checkbox_unselected: () => 'Оквир није потврђен',
  close: () => 'Затвори',
  collection_apply: () => 'Примијени',
  collection_cancel: () => 'Откажи',
  collection_loaded: () => 'Учитано',
  collection_loading: () => 'Учитавање',
  collection_noData: () => 'Нема података за приказ.',
  collection_pixels: () => 'пиксела',
  collection_resizeColumnDialog: () => 'Промијени величину колоне',
  collection_resizeColumnMenu: () => 'Промијени величину колоне...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Унеси број између ' + p['MIN'] + ' и ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Изабери све редове',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Изабери ред ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Узлазно',
  collection_sortColumnMenu: () => 'Сортираj колону',
  collection_sortDescendingSubMenu: () => 'Силазно',
  collection_sortDisabled: () => 'Не може се поредати',
  collection_sortEnabled: () => 'Може се поредати',
  collection_width: () => 'Ширина',
  colorPicker_label: () => 'Бирач боја',
  confirmation: () => 'Потврда',
  datePicker_currentDate: () => 'Тренутни датум',
  datePicker_goToToday: () => 'Иди на данас',
  datePicker_label: () => 'Бирач датума',
  datePicker_month: () => 'Мјесец',
  datePicker_months: () => 'Мјесеци',
  datePicker_next: () => 'Сљедеће',
  datePicker_nextDecade: () => 'Сљедећа декада',
  datePicker_nextMonth: () => 'Сљедећи мјесец',
  datePicker_prev: () => 'Претходно',
  datePicker_prevDecade: () => 'Претходна декада',
  datePicker_prevMonth: () => 'Претходни мјесец',
  datePicker_restricted: () => 'Ограничено',
  datePicker_selected: () => 'Изабрано',
  datePicker_today: () => 'Данас',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + '. седмица',
  datePicker_weekNumColLabel: () => 'Број седмице',
  datePicker_year: () => 'Година',
  datePicker_years: () => 'Године',
  diagram_promotedLink: () => '1 веза',
  diagram_promotedLinkAriaDesc: () => 'Индиректно',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' везе(а)',
  error: () => 'Грешка',
  expandableList_expandCollapseInstructionText: () =>
    'Користи типке са стрелицама за проширивање и сужавање',
  expandableList_groupCollapse: () => 'Сажето',
  expandableList_groupExpand: () => 'Проширено',
  filePicker_addFiles: () => 'Додај датотеке',
  filePicker_dropzonePrimaryText: () => 'Повуци и испусти',
  filePicker_dropzoneSecondaryText: () => 'Изабери датотеку или испусти неку овдје',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Изабери или испусти датотеке овдје',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Не можете учитати датотеке врсте ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Учитај једну по једну датотеку',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Не можете учитати датотеке врсте ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'непознато',
  formControl_clear: () => 'Очисти',
  formControl_day: () => 'Дан',
  formControl_empty_segment: () => 'Празно',
  formControl_helpAvailable: () => 'Доступна је помоћ',
  formControl_hide: () => 'Сакриј',
  formControl_hour: () => 'Сат',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Достигли сте ограничење од ' +
    ((
      {
        one: new Intl.NumberFormat('bs-Cyrl').format(p['CHARACTER_LIMIT']) + ' знака',
        few: new Intl.NumberFormat('bs-Cyrl').format(p['CHARACTER_LIMIT']) + ' знака'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('bs-Cyrl').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('bs-Cyrl').format(p['CHARACTER_LIMIT']) + ' знакова') +
    '.',
  formControl_loading: () => 'Учитавање',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Можете унијети до оволико знакова: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Прекорачена је максимална дужина од ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Преостало знакова: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Милисекунда',
  formControl_minute: () => 'Минута',
  formControl_month: () => 'Мјесец',
  formControl_readOnly: () => 'Само за читање',
  formControl_requiredMessageDetail: () => 'Унеси вриједност.',
  formControl_second: () => 'Секундa',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Изаберите ' + p['n'] + ' вриједност/и.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Достигли сте ограничење одабира од ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Изаберите између ' + p['min'] + ' и ' + p['max'] + ' вриједности.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Изаберите најмање ' + p['min'] + ' вриједност/и.',
  formControl_show: () => 'Прикажи',
  formControl_year: () => 'Година',
  gantt_labelDate: () => 'Датум',
  gantt_labelEnd: () => 'Крај',
  gantt_labelLabel: () => 'Ознака',
  gantt_labelRow: () => 'Ред',
  gantt_labelStart: () => 'Почетак',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Није пронађен ниједан подударан одјељак.',
  indexer_keyboardInstructionText: () => 'Притисни Enter за избор вриједности.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Између ' + p['FROM_SECTION'] + ' и ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Двапут додирнути и држати. Чекати на звук и онда превући да би се преуредило.',
  info: () => 'Информације',
  inputColor_selectColor: () => 'Одабери боју',
  inputDateMask_date_cleared: () => 'Датум је избрисан',
  inputDateMask_dayPlaceholder: () => 'дд',
  inputDateMask_empty_segment: () => 'Празно',
  inputDateMask_monthPlaceholder: () => 'мм',
  inputDateMask_yearPlaceholder: () => 'гггг',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Унеси датум који није каснији од ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Унеси датум који није ранији од ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Унеси доступан датум.',
  inputDatePicker_instruction: () => 'Притисните Таb да бисте приступили календару.',
  inputDatePicker_selectDate: () => 'Изабери датум',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Унеси мјесец и годину који нису каснији од ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Унеси мјесец и годину који нису ранији од ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Унеси број.',
  inputNumber_decrease: () => 'Смањи',
  inputNumber_increase: () => 'Повећај',
  inputPassword_hidden: () => 'Лозинка је скривена',
  inputPassword_hide: () => 'Сакриј лозинку',
  inputPassword_show: () => 'Прикажи лозинку',
  inputSensitiveText_hidden: () => 'Осјетљив текст је скривен',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Унеси вријеме које није касније од ' + p['max'] + '.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Унеси вријеме које није раније од ' + p['min'] + '.',
  inputTimeMask_time_cleared: () => 'Вријеме је избрисано',
  labelNone: () => 'Ништа',
  list_msgFetchCompleted: () => 'Учитано',
  list_msgFetchingData: () => 'Учитавање',
  list_suggestion: () => 'Приједлог',
  menu_stateLoading: () => 'Учитавање',
  messageToast_allMessagesClosed: () => 'Све тоаст поруке су затворене.',
  message_close: () => 'Затвори',
  message_confirmation: () => 'Успјешно',
  message_error: () => 'Грешка',
  message_info: () => 'Информације',
  message_navigationFromMessagesRegion: () =>
    'Подручје за уношење порука. Притисни F6 за навигацију.',
  message_navigationToMessagesRegion: () =>
    'Подручје за поруке садржи нове поруке. Притисни F6 за навигацију.',
  message_navigationToTouch: () => 'Подручје за поруке садржи нове поруке.',
  message_warning: () => 'Упозорење',
  noData_message: () => 'Нема ставки за приказ',
  overflowItemLabel: () => 'Више картица',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Двапут додирни за затварање отвореног скочног прозора.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Улазак у скочни прозор. Притисните F6 за навигацију између скочног прозора и повезане контроле.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Скочни прозор је отворен. Притисните F6 за навигацију између скочног прозора и повезане контроле.',
  progressIndeterminate: () => 'У току',
  radioButton_checked: () => 'Изборно дугме је потврђено',
  radioButton_selected: () => 'Изборно дугме је изабрано',
  radioButton_unchecked: () => 'Изборно дугме није потврђено',
  radioButton_unselected: () => 'Изборно дугме није изабрано',
  radio_helpForRadio: () => 'Помоћ за изборно дугме',
  radio_requiredMessageDetail: () => 'Изабери вриједност.',
  selectMultiple_apply: () => 'Примијени',
  selectMultiple_back: () => 'Назад',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Истакните изабране вриједности помоћу типки с лијевом и десном стрелицом.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Притисните Backspace или Delete да уклоните изабране вриједности.',
  selectMultiple_selectedValues: () => 'Изабране вриједности',
  selectMultiple_showSelectedValues: () => 'Прикажи само изабране вриједности.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Изабрано вриједности: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Додај на списак',
  select_addToListAvailable: () => 'Доступно је додавање на списак',
  select_closeDropdown: () => 'Притисните "Escape" да бисте затворили.',
  select_moreSearchOptions: () => 'Више опција претраживања',
  select_moreSearchOptionsAvailable: () => 'Доступно је више опција претраживања',
  select_noMatchesFound: () => 'Није пронађено ниједно подударање.',
  select_oneMatchFound: () => 'Пронађено је једно подударање',
  select_requiredMessageDetail: () => 'Изабери вриједност.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Пронађено подударанја: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Пронађено подударанја: најманје ' + p['TOTAL_SIZE'],
  selectorAll_deselectAll: () => 'Поништи избор свега',
  selectorAll_selectAll: () => 'Изабери све',
  selector_selected: () => 'Оквир је потврђен',
  selector_unselected: () => 'Оквир није потврђен',
  sheet_close: () => 'Затвори',
  switch_off: () => 'Искључено',
  switch_on: () => 'Укључено',
  tabBarNavigationList_removeCueText: () => 'Може се уклонити',
  tabBar_tabContainsErrors: () => 'Садржи грешке',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Уклоњено: ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'има контекстуални изборник',
  tabbar_labelMoveLeft: () => 'Помакни улијево',
  tabbar_labelMoveRight: () => 'Помакни удесно',
  tabbar_labelRemove: () => 'Уклони',
  timeComponent_tooltipZoomIn: () => 'Увећај',
  timeComponent_tooltipZoomOut: () => 'Умањи',
  timeConverter_parseError: () => 'Унеси потпуно вријеме.',
  train_current: () => 'Тренутно',
  train_message_type: () => 'Врста поруке',
  train_not_visited: () => 'Није посјећено',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Корак ' + p['currentStep'] + ' од ' + p['numberOfSteps'],
  train_visited: () => 'Посјећено',
  userAssistance_learnMore: () => 'Сазнај више',
  userAssistance_required: () => 'Обавезно',
  vis_clearSelection: () => 'Поништи одабир',
  vis_drillable: () => 'Рашчлањиво',
  vis_invalidData: () => 'Неважећи подаци',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' од ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Marquee одабир',
  vis_marqueeZoomTooltip: () => 'Marquee зумирање',
  vis_noData: () => 'Нема података за приказ',
  vis_panTooltip: () => 'Помицање',
  vis_stateCollapsed: () => 'Сажето',
  vis_stateExpanded: () => 'Проширено',
  vis_stateLoaded: () => 'Учитано',
  vis_stateLoading: () => 'Учитавање',
  vis_stateSelected: () => 'Изабрано',
  vis_stateUnselected: () => 'Није изабрано',
  warn: () => 'Упозорење'
};
export default bundle;
